import { Badge } from '../../components/ui/badge';
import { ECMRStatus } from '../../types';

const statusConfig: Record<ECMRStatus, { label: string; variant: 'pending' | 'delivered' | 'transit' | 'cancelled' | 'secondary' }> = {
  draft: { label: 'Rascunho', variant: 'secondary' },
  pending: { label: 'Pendente', variant: 'pending' },
  in_transit: { label: 'Em Trânsito', variant: 'transit' },
  delivered: { label: 'Entregue', variant: 'delivered' },
  cancelled: { label: 'Cancelado', variant: 'cancelled' },
};

interface StatusBadgeProps {
  status: ECMRStatus;
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const config = statusConfig[status];
  return <Badge variant={config.variant}>{config.label}</Badge>;
}
